import React, { useState } from 'react';
import './Contact.css';

const Contact: React.FC = () => {
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Build WhatsApp message
        const msg = encodeURIComponent(
            `Hola CECAP, mi nombre es ${formData.name}.\n${formData.message}\n\nCorreo: ${formData.email}\nTeléfono: ${formData.phone}`
        );
        window.open(`https://wa.me/573008158001?text=${msg}`, '_blank');
        setSubmitted(true);
    };

    return (
        <div className="contact-page">
            {/* Page Header */}
            <div className="contact-header">
                <span className="contact-badge">Estamos para ayudarte</span>
                <h1 className="contact-title">Contáctanos</h1>
                <p className="contact-intro">
                    Resolvemos tus dudas sobre programas, costos e inscripciones. Escríbenos o llámanos, respondemos rápido.
                </p>
            </div>

            <div className="contact-body">
                {/* Info Cards */}
                <div className="contact-info">
                    <div className="contact-info-card">
                        <div className="contact-info-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                                <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/>
                            </svg>
                        </div>
                        <div>
                            <h3>Teléfono / WhatsApp</h3>
                            <a href="tel:+573008158001" className="contact-info-link">300 815 8001 · 301 222 7878</a>
                        </div>
                    </div>

                    <div className="contact-info-card">
                        <div className="contact-info-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                            </svg>
                        </div>
                        <div>
                            <h3>Correo electrónico</h3>
                            <a href="mailto:cecapmaicao@gmail.com" className="contact-info-link">cecapmaicao@gmail.com</a>
                        </div>
                    </div>

                    <div className="contact-info-card">
                        <div className="contact-info-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                            </svg>
                        </div>
                        <div>
                            <h3>Ubicación</h3>
                            <p className="contact-info-text">Carrera 7 #17-36, Barrio San José<br />Maicao, La Guajira</p>
                        </div>
                    </div>

                    <div className="contact-info-card">
                        <div className="contact-info-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
                            </svg>
                        </div>
                        <div>
                            <h3>Horario de atención</h3>
                            <p className="contact-info-text">Lun – Sáb: 8:00 am – 12:00 pm<br />y 2:00 pm – 6:00 pm</p>
                        </div>
                    </div>
                </div>

                {/* Contact Form */}
                <div className="contact-form-wrapper">
                    {submitted ? (
                        <div className="contact-success">
                            <div className="contact-success-icon">
                                <svg viewBox="0 0 24 24" fill="currentColor" width="40" height="40">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                </svg>
                            </div>
                            <h3>¡Mensaje enviado!</h3>
                            <p>Te hemos redirigido a WhatsApp. Responderemos pronto.</p>
                            <button className="contact-submit" onClick={() => setSubmitted(false)}>
                                Enviar otro mensaje
                            </button>
                        </div>
                    ) : (
                        <form className="contact-form" onSubmit={handleSubmit} noValidate>
                            <h2 className="contact-form-title">Envíanos un mensaje</h2>
                            <p className="contact-form-sub">Completa el formulario y te contactaremos a la brevedad.</p>

                            <div className="contact-form-row">
                                <div className="contact-field">
                                    <label htmlFor="name">Nombre completo</label>
                                    <input
                                        id="name"
                                        type="text"
                                        name="name"
                                        placeholder="Tu nombre"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        autoComplete="name"
                                    />
                                </div>
                                <div className="contact-field">
                                    <label htmlFor="email">Correo electrónico</label>
                                    <input
                                        id="email"
                                        type="email"
                                        name="email"
                                        placeholder="tu@correo.com"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        autoComplete="email"
                                    />
                                </div>
                            </div>

                            <div className="contact-field">
                                <label htmlFor="phone">Teléfono (opcional)</label>
                                <input
                                    id="phone"
                                    type="tel"
                                    name="phone"
                                    placeholder="+57 300 000 0000"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    autoComplete="tel"
                                />
                            </div>

                            <div className="contact-field">
                                <label htmlFor="message">Mensaje</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows={5}
                                    placeholder="¿Qué programa te interesa? ¿Tienes alguna pregunta?"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <button type="submit" className="contact-submit">
                                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                                </svg>
                                Enviar por WhatsApp
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Contact;